import { useState } from 'react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { PanelsProvider } from '../../shared/hooks/use-panels';
import { JSONPanel } from '../../export';
import { SettingsPanel } from '../../inspector/components/settings-panel';
import { TimelinePanel } from '../../timeline';
import { CanvasControls } from '../../viewport/components/canvas-controls';
import { OverlayControls } from '../../viewport/components/overlay-controls';
import { LayersControl } from '../../layers/components/layers-control';
import { RightBar } from '../../inspector/components/right-bar';
import { RulerGuides } from '../../snapping/components/ruler-guides';
import { EffectsPanel } from '../../shaders/components/effects-panel';

export interface CreativityEditorProps {
  showTimeline?: boolean;
  kind?: 'editor' | 'form-editor';
}

export const EditorLayout: React.FC<CreativityEditorProps> = ({ showTimeline = true, kind = 'form-editor' }) => {
  const { canvasRef, canvasContainerRef, activeTool } = useEditorCanvas();
  const [showCanvasControls, setShowCanvasControls] = useState(false);

  return (
    <PanelsProvider>
      <div
        style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#F0F0F0' }}
      >
        <div style={{ flex: 1, display: 'flex', overflow: 'hidden', position: 'relative' }}>
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              overflow: 'hidden',
              cursor: activeTool === 'pan' ? 'grab' : 'default',
              userSelect: 'none'
            }}
          >
            <div ref={canvasContainerRef} style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />
            <canvas ref={canvasRef} style={{ position: 'absolute', inset: 0, display: 'block' }} />
            <OverlayControls />
            <RulerGuides />
            {!showTimeline && <LayersControl />}
            <SettingsPanel />
            <RightBar showLoadJson={kind === 'editor'} />
            <EffectsPanel />
          </div>

          <div
            onMouseEnter={() => setShowCanvasControls(true)}
            onMouseLeave={() => setShowCanvasControls(false)}
            style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              paddingTop: 24,
              paddingBottom: 12,
              paddingLeft: 24,
              paddingRight: 24,
              zIndex: 20,
              pointerEvents: 'auto'
            }}
          >
            <div
              style={{
                opacity: showCanvasControls ? 1 : 0,
                transition: 'opacity 0.3s ease'
              }}
            >
              <CanvasControls />
            </div>
          </div>
        </div>

        {showTimeline && <TimelinePanel />}
        <JSONPanel />
      </div>
    </PanelsProvider>
  );
};
